import { getColorsFromCreatorTheme } from '../../../../../features/Common/modules/Theme/utils/Theme.utils.js';
import { getStylesObjFromCss } from '../../../../../utils/common/styling.js';

var styles = getStylesObjFromCss({
    styles: {
        root: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "20px 24px",
            borderBottom: "1px solid #e7e6e4",
            gap: "8px",
        },
        title: {
            color: "rgba(0, 0, 0, 0.85)",
            fontSize: "18px",
            fontWeight: 700,
        },
        cta: {
            fontSize: "14px !important",
            fontWeight: "500 !important",
            textTransform: "none !important",
            padding: "0px !important",
        },
    },
    componentName: "MembersPanelHeader",
});
var getThemedStyles = function (_a) {
    var theme = _a.theme;
    var colors = getColorsFromCreatorTheme(theme);
    return getStylesObjFromCss({
        styles: {
            cta: {
                color: (colors.color1 || "#493AB1") + " !important",
            },
        },
        componentName: "MembersPanelHeader",
    });
};

export { getThemedStyles, styles };
//# sourceMappingURL=MembersPanelHeader.styles.js.map
